// ** Initial State
const initialState = {
    RateCardList: [],
    loading_RateCard: false,
    error_RateCard: ''
  }
  const superAdminReducer = (state = initialState, action) => {
    switch (action.type) {
      // Product
         case 'RateCard_LOADING': {
             return {
                 ...state,
                 loading_RateCard: true,
                 error_RateCard:''
             }
         }
         case 'RateCard_SUCCESS': {
             return {
                 ...state,
                 RateCardList: action.data,
                 loading_RateCard: false
             }
         }
         case 'RateCard_ERROR': {
             return {
                 ...state,
                 loading_RateCard: false,
                 error_RateCard: action.error
             }
         }
      default:
        return state
    }
  }
  
  export default superAdminReducer
  